'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { HERO_PRELOAD_ASSETS, HERO_PRELOAD_GRACE_MS, HERO_PRELOAD_GRACED_ASSET, HERO_PRELOAD_TIMEOUT_MS } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/loading-veil/config';
import type { HeroPreloadAsset, HeroPreloadReturn } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/loading-veil/types';
import { msLeftSince } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/shared/pageClock';
const REQUIRED_ASSETS = HERO_PRELOAD_ASSETS.filter(asset => asset !== HERO_PRELOAD_GRACED_ASSET);

// `clockStartMs` dates the hard timeout -- see useHeroClockStart. Left out,
// it simply runs from mount.
export const useHeroPreload = clockStartMs => {
  const $ = _c(14);
  const [loadedAssets, setLoadedAssets] = useState(_temp);
  const [hasWaitedLongEnough, setHasWaitedLongEnough] = useState(false);
  const [hasGraceElapsed, setHasGraceElapsed] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = asset => {
      setLoadedAssets(loaded => loaded.has(asset) ? loaded : new Set(loaded).add(asset));
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const reportAssetLoaded = t0;
  let t1;
  let t2;
  if ($[1] !== clockStartMs) {
    t1 = () => {
      const timer = window.setTimeout(() => setHasWaitedLongEnough(true), clockStartMs === undefined ? HERO_PRELOAD_TIMEOUT_MS : msLeftSince(clockStartMs, HERO_PRELOAD_TIMEOUT_MS));
      return () => window.clearTimeout(timer);
    };
    t2 = [clockStartMs];
    $[1] = clockStartMs;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== loadedAssets) {
    t3 = REQUIRED_ASSETS.every(asset_0 => loadedAssets.has(asset_0));
    $[4] = loadedAssets;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const haveRequiredLoaded = t3;
  let t4;
  if ($[6] !== loadedAssets) {
    t4 = loadedAssets.has(HERO_PRELOAD_GRACED_ASSET);
    $[6] = loadedAssets;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const hasGracedLoaded = t4;
  let t5;
  let t6;
  if ($[8] !== hasGracedLoaded || $[9] !== haveRequiredLoaded) {
    t5 = () => {
      if (!haveRequiredLoaded || hasGracedLoaded) {
        return;
      }
      const timer_0 = window.setTimeout(() => setHasGraceElapsed(true), HERO_PRELOAD_GRACE_MS);
      return () => window.clearTimeout(timer_0);
    };
    t6 = [haveRequiredLoaded, hasGracedLoaded];
    $[8] = hasGracedLoaded;
    $[9] = haveRequiredLoaded;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  const hasEverythingLoaded = haveRequiredLoaded && hasGracedLoaded;
  const isReady = hasWaitedLongEnough || hasEverythingLoaded || haveRequiredLoaded && hasGraceElapsed;
  let t7;
  if ($[12] !== isReady) {
    t7 = {
      isReady,
      reportAssetLoaded
    };
    $[12] = isReady;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp() {
  return new Set();
}